import rxjs from 'rxjs';
import React from 'react';

import { Plugin as GoalPlugin } from './Views/OfGoals';

export interface Controller {
    dialog?: GoalPlugin,
    openDialog: React.Dispatch<React.SetStateAction<GoalPlugin|undefined>>,
    closeDialog(): void,
    backward(steps?: number, alt?: string): void,
    forward(to: string): void,
    location: { pathname: string }
};

export const Context = React.createContext<Controller> ({
    openDialog: (inspector_) => {},
    closeDialog: () => {},
    backward: (steps?: number, alt?: string) => {},
    forward: (to:string) => {},
    location: { pathname: '' }
});

export function Provider(props: React.PropsWithChildren<{
    useLocation: () => { pathname: string },
    useNavigate: () => (target: string|number) => void,
    watchNavigate: (observer: rxjs.Observer<string>) => void
}>) {
    const location = props.useLocation();
    const navigate = props.useNavigate();

    const [ dialog, _setDialog ] = React.useState<GoalPlugin|undefined>();

    return <Context.Provider value={ { 
        dialog, 
        openDialog: (inspector_) => _setDialog(inspector_),
        closeDialog: () => _setDialog(undefined),
        backward: (steps?: number, alt?: string) => {
            _setDialog(undefined);
            if(!dialog) {
                navigate(steps ? -steps : -1);
            }
        },
        forward: (to: string) => {
            _setDialog(undefined);
            navigate(to);
        },
        location
    } }>{ props.children }</Context.Provider>;
}
